/** @file New-IK row: chain (end bone, 1 or 2 bones) and target bone; the name is a fresh `ik-<end>`. */
import { useState } from 'react';
import { Button } from '../../ui-kit/Button';
import { Select } from '../../ui-kit/Select';
import { boneOptions } from '../rigKit/boneOptions';
import { freshName } from '../rigKit/freshName';
import type { RigView } from '../rigKit/rigView';
import { IkChain } from './IkChain';
import { ikChainBones } from './ikChainBones';

/** ik.create { name, bones, target }; the command checks the chain rules (§6.5) and reports its INFOs. */
export function IkCreate({ doc, t, run }: Pick<RigView, 'doc' | 't' | 'run'>) {
  const bones = boneOptions(doc, (b) => b.kind === undefined);
  const [end, setEnd] = useState(bones[0]?.value ?? '');
  const [length, setLength] = useState<1 | 2>(2);
  const [target, setTarget] = useState(bones[0]?.value ?? '');
  const chain = ikChainBones(doc, end, length);
  const create = (): void => {
    if (chain === null) return;
    const name = freshName(`ik-${doc.bones[end]?.name ?? 'bone'}`, Object.values(doc.constraints).map((c) => c.name));
    run([{ name: 'ik.create', input: { name, bones: chain, target } }]);
  };
  return (
    <fieldset className="rig-fields">
      <legend>{t('panels.constraints.create')}</legend>
      <IkChain t={t} bones={bones} end={end} length={length} onChange={(e, l) => { setEnd(e); setLength(l); }} />
      <Select label={t('panels.constraints.target')} value={target} options={bones} onChange={setTarget} />
      <Button label={t('panels.constraints.create')} primary disabled={chain === null || target === ''} onClick={create} />
    </fieldset>
  );
}
